<template>
  <!-- <template v-slot:header> Hola </template> -->
  <v-form>
    <v-row>
      <v-col cols="12" sm="6">
        <h6>{{ $t("info_card.race") }}</h6>
        <v-autocomplete
          v-model="race_id"
          :items="races"
          :item-title="(item) => objectTranslator(item, 'RACE_NAME')"
          :item-value="(item) => item.RACE_ID"
          :rules="requiredRules"
          variant="outlined"
          density="compact"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" sm="6">
        <h6>{{ $t("info_card.religion") }}</h6>
        <v-autocomplete
          v-model="religion_id"
          :items="religions"
          :item-title="(item) => objectTranslator(item, 'RELIGION_NAME')"
          :item-value="(item) => item.RELIGION_ID"
          :rules="requiredRules"
          variant="outlined"
          density="compact"
        ></v-autocomplete>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { objectTranslator } from "@/helper/translator";
import validator from "@/helper/validator";
export default {
  name: "RaceReligionCard",
  props: {
    modelValue: Object,
  },

  data: () => ({
    requiredRules: [validator.required],
  }),

  methods: {
    objectTranslator,
  },

  computed: {
    races: function () {
      return this.$store.state.ref.races;
    },
    religions: function () {
      return this.$store.state.ref.religions;
    },

    race_id: {
      get() {
        return this.modelValue.race_id;
      },
      set(val) {
        this.$emit("update:modelValue", {
          race_id: val,
          religion_id: this.religion_id,
        });
      },
    },
    religion_id: {
      get() {
        return this.modelValue.religion_id;
      },
      set(val) {
        this.$emit("update:modelValue", {
          race_id: this.race_id,
          religion_id: val,
        });
      },
    },
  },

  created() {
    this.$store.dispatch("ref/getRaces");
    this.$store.dispatch("ref/getReligions");
  },
};
</script>
